 

import { moreCourses } from "../../../data/cad_section/moreCourses";

import CourseEnquiryButton from "../../CAD_Home/CourseEnquiryButton";
import CourseDetails from "../../common/CourseDetails/CourseDetails";
import PlaceMentRecord from "../../common/PlaceMent/PlaceMentRecord";
import CadWhyFeesWorth from "../CadWhyFeesworth/CadWhyFeesWorth";
import CourseDemoVideos from "../CourseDemoVideos/CourseDemoVideos";
import CourseFAQ from "../CourseFAQ/CourseFAQ";
import CourseHero from "../CourseHero/CourseHero";
import CourseHighlights from "../CourseHighlights/CourseHighlights";
import CourseSyllabus from "../CourseSyllabus/CourseSyllabus";
import MoreCourses from "../MoreCourses/MoreCourses";
import WhyLearnCourse from "../WhyLearnCourse/WhyLearnCourse";

import "./CourseLandingPage.css";


function CourseLandingPage({ course }) {

    return (
        <div className="course-landing-page">

            <CourseHero
                course={course}
            />         

            <CourseHighlights
                courseName={course.name}
                highlights={course.highlights}
            />


            <WhyLearnCourse
                courseName={course.name}
                reasons={course.whyLearn}
            />


            {/* =========================================
                PLACEMENT RECORD
            ========================================= */}

            <section id="placement-record">

                <PlaceMentRecord />

            </section>


            <CourseSyllabus
                courseName={course.name}
                syllabus={course.syllabus}
            />


            <CourseEnquiryButton />


            {/* =========================================
                SAMPLE PROJECT VIDEOS
            ========================================= */}

            <section id="sample-project-video">

                <CourseDemoVideos
                    videos={course.videos}
                />

            </section>


            <MoreCourses
                courses={moreCourses}
            />


            <CourseDetails />


            <CourseEnquiryButton />


            <CadWhyFeesWorth />


            <CourseFAQ
                faqs={course.faq}
            />

        </div>
    );
}

export default CourseLandingPage;